import * as React from "react"
import { BaseIconProps } from "./type"

const NoData: React.FC<BaseIconProps> = (props) => {
  const { size = 104 } = props;
  return (
    <svg
      style={{ width: `${size}px`, height: `${size}px` }}
      viewBox={`0 0 104 104`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#no_data1)">
        <path
          d="M52 104c28.719 0 52-4.335 52-9.682s-23.281-9.681-52-9.681S0 88.97 0 94.318C0 99.665 23.281 104 52 104Z"
          fill="#F5F5F7"
          fillOpacity={0.8}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m93.601 63.649-18.35-22.503c-.88-1.06-2.168-1.7-3.523-1.7H32.274c-1.355 0-2.642.64-3.522 1.7l-18.35 22.503v11.756h83.2V63.65Z"
          fill="#AEB8C2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.947 0H78.05c.814 0 1.594.322 2.17.895.575.574.898 1.351.898 2.162v71.337c0 .811-.323 1.589-.898 2.162a3.074 3.074 0 0 1-2.17.895H25.947a3.074 3.074 0 0 1-2.17-.895 3.051 3.051 0 0 1-.898-2.162V3.057c0-.81.323-1.588.898-2.162A3.074 3.074 0 0 1 25.947 0Z"
          fill="#F5F5F7"
        />
        <path
          d="M71.265 8.348H32.734c-.407 0-.797.16-1.085.447-.288.287-.45.676-.45 1.081V28.95c0 .406.162.794.45 1.081.288.287.678.448 1.085.448h38.531c.407 0 .797-.161 1.085-.448.288-.287.45-.675.45-1.08V9.875a1.537 1.537 0 0 0-1.534-1.528ZM71.064 38.775h-38.13c-.46 0-.9.182-1.226.507a1.725 1.725 0 0 0 0 2.444c.325.325.766.507 1.227.507h38.13c.46 0 .9-.182 1.226-.507a1.726 1.726 0 0 0-1.227-2.95ZM71.064 47.765h-38.13c-.46 0-.901.182-1.226.507a1.726 1.726 0 0 0 0 2.445c.325.324.766.506 1.227.506h38.13c.46 0 .9-.182 1.226-.506a1.726 1.726 0 0 0-1.227-2.952Z"
          fill="#DCE0E6"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M93.429 90.67c-.595 2.347-2.682 4.097-5.166 4.097h-72.53c-2.483 0-4.57-1.75-5.164-4.096a5.57 5.57 0 0 1-.17-1.368V63.649h20.185c2.23 0 4.027 1.871 4.027 4.142v.031c0 2.27 1.818 4.104 4.047 4.104h26.68c2.23 0 4.048-1.85 4.048-4.122v-.009c0-2.271 1.797-4.147 4.026-4.147h20.186v25.655c0 .472-.059.93-.17 1.368Z"
          fill="#DCE0E6"
        />
      </g>
      <defs>
        <clipPath id="no_data1">
          <path fill="#fff" d="M0 0h104v104H0z" />
        </clipPath>
      </defs>
    </svg>
  )


  // return (
  //   <svg
  //     width={104}
  //     height={104}
  //     fill="none"
  //     xmlns="http://www.w3.org/2000/svg"
  //     {...props}
  //   >
  //     <path
  //       d="m24.143 72.059 7.428 7.8-15.971 18.2c-1.981 1.981-6.909 5.2-10.772 2.228-3.863-2.971-2.352-7.676-1.114-9.657l20.429-18.571Z"
  //       fill="#AEB8C2"
  //     />
  //     <path
  //       fillRule="evenodd"
  //       clipRule="evenodd"
  //       d="M99.13 64.017a8.249 8.249 0 0 0-1.047-2.274 40.457 40.457 0 0 0 5.916-21.12C103.999 18.223 85.776 0 63.376 0c-10.68 0-20.41 4.143-27.67 10.906a8.342 8.342 0 0 0-6.493-2.282c-2.21-2.825-5.646-4.53-9.27-4.53-5.805 0-10.64 4.229-11.585 9.768-3.417.405-6.076 3.32-6.076 6.844 0 3.8 3.077 6.892 6.86 6.892h15.753a40.457 40.457 0 0 0-2.142 13.025c0 8.297 2.5 16.02 6.786 22.457L2.616 88.88l-.03.03c-3.448 3.447-3.448 9.056 0 12.503a8.81 8.81 0 0 0 6.25 2.585 8.81 8.81 0 0 0 6.282-2.616l25.8-26.924a40.392 40.392 0 0 0 22.458 6.787c6.373 0 12.467-1.432 18.122-4.257h15.9a6.609 6.609 0 0 0 6.601-6.601c0-3.041-2.067-5.609-4.87-6.371ZM9.142 23.535c-1.517 0-2.798-1.296-2.798-2.83 0-1.56 1.27-2.829 2.83-2.829h1.048c1.122 0 2.031-.909 2.031-2.03 0-4.241 3.45-7.69 7.69-7.69a7.637 7.637 0 0 1 6.598 3.737 2.03 2.03 0 0 0 2.282.912 4.264 4.264 0 0 1 4.053 1.013 40.758 40.758 0 0 0-6.352 9.717H9.142Zm3.06 75.02a4.784 4.784 0 0 1-6.744-.013 4.784 4.784 0 0 1-.014-6.744L23.847 74.16l5.99 5.99-17.636 18.405Zm20.447-21.337L26.78 71.35l5.196-4.98a40.98 40.98 0 0 0 5.651 5.651l-4.98 5.197Zm-5.833-36.595c0-20.16 16.4-36.56 36.56-36.56 20.16 0 36.561 16.4 36.561 36.56 0 6.48-1.695 12.775-4.92 18.329a8.237 8.237 0 0 0-4.165-.965c3.291-5.192 5.023-11.16 5.023-17.364 0-17.92-14.579-32.498-32.499-32.498a32.57 32.57 0 0 0-15.134 3.734 2.031 2.031 0 0 0 1.895 3.594 28.487 28.487 0 0 1 13.24-3.266c15.679 0 28.435 12.756 28.435 28.436a28.24 28.24 0 0 1-4.174 14.842 11.78 11.78 0 0 0-6.513-1.98c-5.804 0-10.64 4.229-11.585 9.768a6.906 6.906 0 0 0-5.998 5.806h-.166c-15.68 0-28.436-12.756-28.436-28.436 0-4.61 1.13-9.187 3.266-13.239a2.031 2.031 0 1 0-3.594-1.894 32.566 32.566 0 0 0-3.734 15.133c0 17.92 14.578 32.498 32.498 32.498.3 0 .548 0 .782-.004a6.895 6.895 0 0 0 4.568 3.683c-1.755.255-3.54.384-5.35.384-20.16 0-36.56-16.401-36.56-36.561Zm70.582 32.304H70.324c-1.517 0-2.798-1.296-2.798-2.83 0-1.56 1.27-2.83 2.83-2.83h1.048c1.122 0 2.031-.909 2.031-2.03 0-4.24 3.45-7.69 7.69-7.69a7.637 7.637 0 0 1 6.598 3.737 2.03 2.03 0 0 0 2.282.913 4.256 4.256 0 0 1 1.132-.153c2.211 0 4.071 1.724 4.236 3.925a2.031 2.031 0 0 0 2.025 1.88c1.4 0 2.539 1.138 2.539 2.539 0 1.4-1.139 2.539-2.539 2.539ZM53.222 42.654a2.031 2.031 0 1 0 0-4.062h-.002a2.03 2.03 0 1 0 .002 4.062Zm10.155 0a2.031 2.031 0 1 0 0-4.062h-.001a2.03 2.03 0 1 0 .001 4.062Zm12.188-2.031a2.031 2.031 0 1 1-2.033-2.031h.001c1.122 0 2.032.909 2.032 2.03Zm-31.7-21.544a2.031 2.031 0 1 1-2.033-2.031h.001c1.122 0 2.031.91 2.031 2.031Z"
  //       fill="#DCE0E6"
  //     />
  //   </svg>
  // )
}

export default NoData
